import { type User } from '@prisma/client'
import { type ObjectValues } from '#app/utils/typescript-helpers.js'
import { type IChatMember } from './chat-member._._definitions'
import { type IMessageTemplate } from './message-template._._definitions'
import { type IMessage } from './message._._definitions'
import { type IPushSubscription } from './push-subscription._._definitions'
import { type IUserActivity } from './user-activity._._definitions'
import { type IUserImage } from './user-image._._definitions'
import { type IUserProfileAi } from './user-profile-ai._._definitions'
import { type IUserProfile } from './user-profile._._definitions'
import { type IUserRole } from './user-role._._definitions'

export interface IUser extends User {
	type: IUserType
	status: IUserStatus

	profile?: IUserProfile
	profileAi?: IUserProfileAi
	image?: IUserImage
	roles?: IUserRole[]
	chats?: IChatMember[]
	messageTemplates?: IMessageTemplate[]
	messages?: IMessage[]
	activities?: IUserActivity[]
	pushSubscriptions?: IPushSubscription[]
}

export const USER_TYPE = {
	USER: 'user',
	AI: 'ai',
	SYSTEM: 'system',
} as const
export type IUserType = ObjectValues<typeof USER_TYPE>

export const USER_STATUS = {
	PENDING: 'pending',
	ONBOARDING: 'onboarding',
	APPROVED: 'approved',
	REJECTED: 'rejected',
	SUSPENDED: 'suspended',
} as const
export type IUserStatus = ObjectValues<typeof USER_STATUS>
export const USER_STATUS_VALUES: string[] = Object.values(USER_STATUS)

export const USER_ONBOARDING_STATUS = {
	ACCOUNT: 'account',
	PROFILE: 'profile',
	ACTIVITIES: 'activities',
	LIFESTYLE: 'lifestyle',
	TASTES: 'tastes',
	COMPLETE: 'complete',
} as const
export type IUserOnboardingStatus = ObjectValues<typeof USER_ONBOARDING_STATUS>
export const USER_ONBOARDING_STATUS_VALUES: string[] = Object.values(
	USER_ONBOARDING_STATUS,
)
